import { StringField } from '../../../types/types';

import { TCustomHtmlComponentProps, TCustomHtmlComponentFields } from '../types/customHtmlComponent.types';

export class CustomHtmlComponentModel {
  private readonly fields: null | TCustomHtmlComponentFields;

  constructor(props: TCustomHtmlComponentProps) {
    this.fields = props?.fields || null;
  }

  get getInnerHtml(): StringField | undefined {
    return this.fields?.customHtml;
  }
}
